import { useEffect, useState } from "react";
import api, { BACKEND_URL } from "@/lib/api";

export function absolutePhotoUrl(photo_url) {
  if (!photo_url) return null;
  if (photo_url.startsWith("http")) return photo_url;
  return `${BACKEND_URL}${photo_url}`;
}

export default function useProfile() {
  const [profile, setProfile] = useState(null);
  useEffect(() => {
    api
      .get("/profile")
      .then((r) => setProfile(r.data))
      .catch(() => setProfile({}));
  }, []);
  return profile;
}
